import { PlusOutlined } from '@ant-design/icons';
import { Col, DatePicker, DatePickerProps, Row, Table, Tag } from "antd";
import { ContentHeader } from "../../../components";
import Column from "antd/es/table/Column";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Links } from "../../../helpers/Links";
import { Link } from "react-router-dom";
import { menuHelper } from "../../../helpers/account";
import { layDsPhatSinhTinhThue } from '../../../services/luong';
import { layKieuTinhUngHo, layLoaiUngHo } from '../../../helpers/common';
import dayjs, { Dayjs } from 'dayjs';
import { DanhSachKhenThuongUngHoResponse } from '../../../models/luong/Luong';

const DanhSachPhatSinhTinhThue = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [dataTable, setDataTable] = useState<Array<DanhSachKhenThuongUngHoResponse>>();
    const menu: any = menuHelper.checkMultiPermission([Links.Luong.PhatSinhTinhThue, Links.Luong.ChiTietPhatSinhTinhThue]);
    const [ngayThang, setNgayThang] = useState<Dayjs | null>(dayjs());
    let thangHienTai = (dayjs()).startOf('month').format('DD/MM/YYYY HH:mm:ss');

    const layDuLieu = async (date: string) => {
        try {
            setIsLoading(true);
            var rs = await layDsPhatSinhTinhThue(date);
            setDataTable((rs || []).map((v: DanhSachKhenThuongUngHoResponse) => { return { ...v, key: v.id } }));
            setIsLoading(false);
        }
        catch (err: any) {
            toast.error(err);
            setIsLoading(false);
        }
    }

    const monthFormat = 'MM/YYYY';
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;
    const onChange: DatePickerProps['onChange'] = (date) => {
        var dateStr = date?.startOf('month').format('DD/MM/YYYY HH:mm:ss');
        setNgayThang(date);
        if (dateStr) {
            layDuLieu(dateStr);
        } else {
            layDuLieu("");
        }
    }

    useEffect(() => {
        layDuLieu(thangHienTai);
    }, [])

    return (
        <section>
            <ContentHeader title="Danh sách phát sinh tính thuế" />
            <Row className="mb-2">
                <Col span="6">
                    <DatePicker changeOnBlur={true} value={ngayThang} style={{ width: "100%" }} placeholder="Tháng" picker="month" format={thangNamFormat} onChange={onChange} />
                </Col>
                <Col span="18">
                    {
                        menu[Links.Luong.ChiTietPhatSinhTinhThue] &&
                        <Link className="hrm-btn float-right hrm-btn-warning" to={Links.Luong.ChiTietPhatSinhTinhThue}><PlusOutlined />Thêm mới</Link>
                    }
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={dataTable}
                            loading={isLoading}
                            locale={{ emptyText: "Không có dữ liệu" }}
                        >
                            <Column title="Tháng" dataIndex="thoiGian" key="thoiGian" />
                            <Column title="Tên" dataIndex="ten" key="ten" />
                            <Column title="Loại phát sinh" dataIndex="loai" key="loai" render={(text: string) => layLoaiUngHo(text)} />
                            <Column title="Mức tính" dataIndex="loaiUngHo" key="loaiUngHo" render={(text: string) => layKieuTinhUngHo(text)} />
                            <Column title="Số lượng CBCNV" dataIndex="soLuongCBCNV" key="soLuongCBCNV" />
                            <Column title="Trạng thái" dataIndex="khoaDieuChinh" key="khoaDieuChinh" render={(value, record) => {
                                var tag = (<Tag color="default"></Tag>);
                                switch (value) {
                                    case 0: tag = (<Tag color="success">Khởi tạo</Tag>); break;
                                    case 1: tag = (<Tag color="red">Khóa điều chỉnh</Tag>); break;
                                }
                                return tag;
                            }} />
                            {
                                menu[Links.Luong.ChiTietPhatSinhTinhThue] &&
                                <Column title="" dataIndex="action" key="action" render={(value: any, record: any) => {
                                    return <Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.Luong.ChiTietPhatSinhTinhThue + "?id=" + record.id}>Xem</Link>
                                }} />
                            }
                        </Table>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DanhSachPhatSinhTinhThue;
